import React, { useEffect, useState } from "react";
import Modal from "gp-modal";
import "gp-modal/dist/index.css";
import Services from "./services";
import { useHistory } from "react-router-dom";

import serviceCenso from "./services";

import { message } from "antd";
import { useModoSomenteLeitura } from "../../component/Security/useModoSomenteLeitura";

const ModalHistorico = ({ show, close, cpf, nome, onRetificar }) => {
  const [historico, setHistorico] = useState([]);
  const history = useHistory();

  const modoSomenteLeitura = useModoSomenteLeitura();

  const visualizar = (e, item) => {
    return Services.visualizar(item.id);
  };

  useEffect(() => {
    if (show) {
      Services.obterHistorico(cpf)
        .then((response) => response.data)
        .then(setHistorico)
        .catch((e) => console.log);
    }
  }, [show]);

  const emitirComprovante = async (id) => {
    if (!id) {
      message.warning("Não foi possível emitir o comprovante.");
      return;
    }

    try {
      await serviceCenso.visualizar(id);
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || "Erro ao emitir o comprovante.";

      message.error(errorMessage, 4);
      console.error("Erro ao emitir comprovante:", error);
    }
  };

  return (
    <>
      <Modal
        title={`Histórico de Recadastramento de ${nome}`}
        showModal={show}
        closeModal={close}
        classeSize={"modal-xl"}
      >
        <div className="modal-body">
          <table className="table table-sm table-bordered table-align table-striped">
            <thead className="thead-light">
              <tr>
                <th className="text-center">Referência</th>
                <th className="text-center">Data de Recadastro</th>
                <th className="text-center">Situação</th>
                <th className="text-center">Local</th>
                <th className="text-center">Atendente</th>
                <th className="text-center" width="12%">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody>
              {historico.length > 0 ? (
                historico.map((item, index) => (
                  <tr key={index}>
                    <td className="text-center">{item.descricao}</td>
                    {item.id ? (
                      <>
                        <td className="text-center">{item.data}</td>
                        <td className="text-center">{item.situacao}</td>
                        <td className="text-center">
                          {item.localidade ? item.localidade : "-"}
                        </td>
                        <td className="text-center">
                          {item.atendente ? item.atendente : "-"}
                        </td>
                        <td className="text-left">
                          {item.permiteEmitirComprovante && (
                            <button
                              type="button"
                              onClick={(event) => visualizar(event, item)}
                              title="Emitir Documento"
                              className="btn btn-outline-success btn-sm ml-1"
                            >
                              <i className="fa fa-file-alt m-0"></i>
                            </button>
                          )}
                          {(item.permiteRetificar && !modoSomenteLeitura) && (
                            <button
                              type="button"
                              onClick={() =>
                                onRetificar(item.id, item.anoReferencia)
                              }
                              title="Retificar"
                              className="btn btn-outline-success btn-sm btn-sm ml-1"
                            >
                              <i className="fa fa-edit m-0"></i>
                            </button>
                          )}
                          {item.id && (
                            <>
                              <button
                                type="button"
                                onClick={() => {
                                  close();
                                  history.push(
                                    `/recadastramento/censo/${cpf}/${item.id}`
                                  );
                                  window.location.reload();
                                }}
                                title="Visualizar"
                                className="btn btn-outline-success btn-sm btn-sm ml-1"
                              >
                                <i className="fa fa-eye m-0"></i>
                              </button>

                              {item.dataConclusao && (
                                <button
                                  type="button"
                                  title="Comprovante"
                                  className="btn btn-outline-success btn-sm ml-1"
                                  onClick={() => emitirComprovante(item.id)}
                                >
                                  <i className="fa fa-file m-0" />
                                </button>
                              )}
                            </>
                          )}
                        </td>
                      </>
                    ) : (
                      <>
                        <td className="text-center">-</td>
                        {item.situacao ? (
                          <td className="text-center">{item.situacao}</td>
                        ) : (
                          <td className="text-center">Não Realizado</td>
                        )}
                        <td className="text-center">-</td>
                        <td className="text-center">-</td>
                        <td className="text-center"></td>
                      </>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="noResult text-center">
                    {" "}
                    Nenhum registro encontrado
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="modal-footer p-3">
          <button
            type="button"
            className="btn btn-outline-dark"
            onClick={close}
          >
            <i className="fas fa-times" />
            Voltar
          </button>
        </div>
      </Modal>
    </>
  );
};

export default ModalHistorico;
